import { render } from "./RemoveContactCard.vue?vue&type=template&id=e9ece292&scoped=true"
import script from "./RemoveContactCard.vue?vue&type=script&lang=js"
export * from "./RemoveContactCard.vue?vue&type=script&lang=js"

import "./RemoveContactCard.vue?vue&type=style&index=0&id=e9ece292&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ece292"]])

export default __exports__